import { UPDATE_ADMIN } from "../Actions/adminActions";

const INITIAL_STATE = {
  users: [],
  editManagement: [],
  editManagementBoolean: [],
  editManagementNexus: null,
  //   {
  //     id: 1,
  //     updatedAt: "2022-10-26T12:59:48+00:00",
  //     content: "Présentation de foufou de Réseau Pro",
  //     value: false,
  //     editedByUniversity: "XYZ Univ",
  //     editorialManagement: "presentationRP",
  //   },
  //   {
  //     id: 2,
  //     updatedAt: "2022-10-26T13:00:49+00:00",
  //     content: "",
  //     value: true,
  //     editedByUniversity: "XYZ Univ",
  //     editorialManagementBoolean: "visibleConseils",
  //   },
  //   {
  //     id: 3,
  //     updatedAt: "2022-10-26T13:00:49+00:00",
  //     content: "Conseils Test",
  //     value: false,
  //     editedByUniversity: "XYZ Univ",
  //     editorialManagement: "conseilsTitle",
  //   },
  // ],
  // ----------------------- GESTION EDITORIALE
  // présentation de Réseau Pro
  // presentationRP:
  //   "Bienvenue sur RéseauPro, le portail qui met en relation les étudiants avec les professionnels, permet la rencontre directe de l'offre recruteur avec les étudiants, propose offres et événements professionnels pour les étudiants.",
  // // faire partie de Réseau Pro sur la page Nos universités
  // partieRP: "",
  // // présentation de l'université sur la page Nos universités
  // presentationUniv: "",
  // // comment rejoindre Réseau Pro sur la page espace recruteur
  // rejoindreRP: "",
  // // charte Réseau Pro au moment de la connexion
  // charteRP: "",
  // id: null,
  // accueilTitle: "Home",
  // evenementsTitle: "Event",
  // actusTitle: "News",
  // offresTitle: "Offers",
  // groupesTitle: "Groups",
  // annuaireTitle: "List",
  // conseilsTitle: "Advices",
  // projetsTitle: "Projects",
  // visibleAnnuaire: true,
  // visibleAnnuaireEtudiant: true,
  // visibleAnnuaireAlumni: true,
  // visibleAnnuaireEntreprise: true,
  // visibleConseils: true,
  // visibleProjets: false,
  // },
  currentPage: 1,
  paginationBasicFirst: 0,
  paginationBasicRows: 8,
};

const adminReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case UPDATE_ADMIN: {
      return {
        ...state,
        ...action.value,
      };
    }

    default:
      return state;
  }
};

export default adminReducer;
